/**
 * Pastille de date limite.
 *
 * Elle ne clignote jamais et ne pulse jamais : c'est une information
 * PASSIVE. (À l'inverse de la cloche de jongle, qui balance — parce qu'un
 * rappel raté EST le mode d'échec de cette app-là. Ici, rater une DLC coûte
 * un yaourt.)
 *
 * Elle réutilise exactement les deux teintes d'état, ambre et brique :
 * « attention » et « trop tard » sont les mêmes deux niveaux d'urgence, une
 * troisième couleur serait une invention. C'est la FORME qui la distingue
 * d'un état de stock, pas la teinte.
 */
export function joursAvant(date: string, maintenant: Date): number {
  const [a, m, j] = date.split('-').map(Number)
  const cible = new Date(a!, m! - 1, j!)
  const aujourdhui = new Date(maintenant.getFullYear(), maintenant.getMonth(), maintenant.getDate())
  return Math.round((cible.getTime() - aujourdhui.getTime()) / 86_400_000)
}

export function BadgeDlc({ date, maintenant = new Date() }: { date: string; maintenant?: Date }) {
  const j = joursAvant(date, maintenant)

  const texte = j < 0 ? 'périmé' : j === 0 ? "aujourd'hui" : j === 1 ? 'demain' : `J-${j}`
  const style =
    j < 0
      ? 'bg-epuise-soft text-epuise-ink'
      : j <= 3
        ? 'bg-bientot-soft text-bientot-ink'
        : 'bg-surface-sunk text-ink-soft'

  return (
    <span className={`tnum shrink-0 rounded-xs px-1.5 py-0.5 text-label ${style}`}>{texte}</span>
  )
}
